<!-- report_influencer_value.vue -->
<template>
  <component
      :is="valueComponent"
      :column="column"
      :report_id="report_id"
      :ig_id="ig_id"
      :index="index"
      :value="value"
      :type="type"
      :sns_type="sns_type"
      @openMedia="$emit('openMedia', $event)"
      @storiesReactive="$emit('storiesReactive', $event)"
      @openInfluencer="$emit('openInfluencer', $event)"
  />
</template>

<script>
import reportInfluencerValueInstagram from "./report_influencer_value_instagram.vue";
import reportInfluencerValueX from "./report_influencer_value_x.vue";
import reportInfluencerValueTiktok from "./report_influencer_value_tiktok.vue";

export default {
  name: "reportInfluencerValue",
  props: {
    column: { type: String, required: true },
    report_id: { type: [String, Number], required: true },
    ig_id: { type: [String, Number], default: null },
    index: { type: Number, required: true },
    value: { required: false },
    type: { type: String, default: "" },
    sns_type: { type: String, default: "instagram" },
  },
  components: {
    reportInfluencerValueInstagram,
    reportInfluencerValueX,
    reportInfluencerValueTiktok,
  },
  computed: {
    valueComponent() {
      const st = (this.sns_type || "").toString();
      if (st === "tiktok") return "reportInfluencerValueTiktok";
      if (st === "x") return "reportInfluencerValueX";
      return "reportInfluencerValueInstagram";
    },
  },
};
</script>
